import { render } from "./detail.vue?vue&type=template&id=0cc607f9&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=0cc607f9&lang=css"
import "./detail.vue?vue&type=style&index=1&id=0cc607f9&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/frontend-offical-website/master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc607f9"]])

export default __exports__